<template>
    <span :class="textClass">{{ row.Bakiye || '-' }}</span>
</template>

<script>
export default {
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{
        textClass(){
            return 'text-danger font-weight-bolder'          
        }
    }
}
</script>